import React, { memo } from 'react';
import { NodeProps } from 'reactflow';
import { ActionNodeData } from '../../types/nodes';
import N8NStyleNode from './N8NStyleNode';

const ModernActionNode = memo(({ data, selected }: NodeProps<ActionNodeData>) => {
  const getIcon = () => {
    const icons: Record<string, string> = {
      'send_message': '📤',
      'send_media': '🖼️',
      'send_location': '📍',
      'send_contact': '👤',
      'add_to_group': '➕',
      'remove_from_group': '➖',
      'send_to_group': '📢',
      'create_group': '🆕',
      'set_group_admin': '👑',
      'add_label': '🏷️',
      'wait': '⏱️',
    };
    return icons[data.actionType] || '📤';
  };

  const getLabel = () => {
    const labels: Record<string, string> = {
      'send_message': 'Invia Messaggio',
      'send_media': 'Invia Media',
      'send_location': 'Invia Posizione',
      'send_contact': 'Invia Contatto',
      'add_to_group': 'Aggiungi al Gruppo',
      'remove_from_group': 'Rimuovi dal Gruppo',
      'send_to_group': 'Invia al Gruppo',
      'create_group': 'Crea Gruppo',
      'set_group_admin': 'Imposta Admin',
      'add_label': 'Aggiungi Etichetta',
      'wait': 'Attendi',
    };
    return labels[data.actionType] || data.label;
  };

  const getSubtitle = () => {
    const config = data.config || {};
    const anyData = data as any;
    
    if (config.groupName || anyData.groupName) {
      return config.groupName || anyData.groupName;
    }
    if (config.message) {
      return config.message.substring(0, 30) + (config.message.length > 30 ? '...' : '');
    }
    if (anyData.description) {
      return anyData.description;
    }
    return 'Azione';
  };

  return (
    <N8NStyleNode
      selected={selected}
      icon={getIcon()}
      label={getLabel()}
      subtitle={getSubtitle()}
      color="#3b82f6"
      handles={{ source: true, target: true }}
    />
  );
});

ModernActionNode.displayName = 'ModernActionNode';

export default ModernActionNode;
